import t from 'tcomb';
import Register_Country from './Register_Country';
import Locale_Iso from './Locale_Iso';
import Pin from './Pin';
import Gender from './Gender';
import Order from './Order';
import Behaviour from './Behaviour';
import http from '../../http';
import Email from './Email';
import UUID from './UUID';
import URL from './URL';
import Datetime from './Datetime';
import Amount from './Amount';

// FIXME usare ../../endpoint.js invece che http()
export default function Server(rest_base: t.String, async: ?t.Boolean) {

  async = t.Nil.is(async) ? true : async;

  this.load_user = http({
    async: async,
    url: rest_base + 'user',
    method: 'get'
  });

  this.do_login = http({
    async: async,
    url: rest_base + 'user/login',
    method: 'post',
    form_params: {
      emailAddress: Email,
      password: t.String
    }
  });

  this.load_facebook = http({
    async: async,
    url: rest_base + 'user/login/facebook',
    method: 'post',
    form_params: {
      target: URL,
      com_locale: Locale_Iso
    }
  });

  this.load_google = http({
    async: async,
    url: rest_base + 'user/login/google',
    method: 'post',
    form_params: {
      target: URL,
      com_locale: Locale_Iso
    }
  });

  this.load_twitter = http({
    async: async,
    url: rest_base + 'user/login/twitter',
    method: 'post',
    form_params: {
      target: URL,
      com_locale: Locale_Iso,
      lattice_id: t.maybe(UUID)
    }
  });

  this.load_microsoft = http({
    async: async,
    url: rest_base + 'user/login/microsoft',
    method: 'post',
    form_params: {
      target: URL,
      com_locale: Locale_Iso
    }
  });

  this.do_resend_password = http({
    async: async,
    url: rest_base + 'user/password/reset',
    method: 'post',
    form_params: {
      emailAddress: Email
    }
  });

  this.do_request_pin = http({
    async: async,
    url: rest_base + 'user/mobile',
    method: 'post',
    form_params: {
      mobileCountry: Register_Country,
      mobileNumber: t.String
    }
  });

  this.do_insert_pin = http({
    async: async,
    url: rest_base + 'user/mobile/pin',
    method: 'post',
    form_params: {
      pin: Pin
    }
  });

  this.do_verify = http({
    async: async,
    url: rest_base + 'user/verify',
    method: 'post',
    form_params: {
      gender: Gender,
      birth_date: Datetime,
      country: Register_Country,
      district: t.String,
      zip: t.String
    }
  });

  this.load_purchases = http({
    async: async,
    url: rest_base + 'user/orders',
    method: 'get'
  });

  this.load_purchase = http({
    async: async,
    url: rest_base + 'order/<%= purchase_id %>?target=<%= target %>&cancel_target=<%= cancel_target %>',
    method: 'get',
    url_params: {
      purchase_id: UUID,
      target: URL,
      cancel_target: URL
    }
  });

  this.do_send_gift_card_code = http({
    async: async,
    url: rest_base + 'order/<%= purchase_id %>/giftcard',
    method: 'post',
    url_params: {
      purchase_id: UUID
    },
    form_params: {
      gift_card_code: t.String,
      target: URL,
      cancel_target: URL
    }
  });

  this.do_register = http({
    async: async,
    url: rest_base + 'user/account',
    method: 'post',
    form_params: {
      emailAddress: Email,
      com_locale: Locale_Iso,
      privacy_rcs: t.maybe(t.String),
      privacy_other: t.maybe(t.String),
      privacy_tracking: t.maybe(t.String)
    }
  });

  this.do_logout = http({
    async: async,
    url: rest_base + 'user/logout',
    method: 'post'
  });

  this.do_change_password = http({
    async: async,
    url: rest_base + 'user/password',
    method: 'post',
    form_params: {
      oldPassword: t.String,
      newPassword: t.String
    }
  });

  this.do_update_account = http({
    async: async,
    url: rest_base + 'user',
    method: 'post',
    form_params: {
      name: t.String,
      surname: t.String,
      gender: Gender,
      birth_date: Datetime,
      country: Register_Country,
      district: t.String,
      zip: t.String,
      com_locale: Locale_Iso
    }
  });

  this.do_approve_order = http({
    async: async,
    url: rest_base + 'product/<%= product_id %>/buy',
    method: 'post',
    url_params: {
      product_id: UUID
    },
    form_params: {
      price: Amount,
      order: Order
    }
  });

  this.load_runtime = http({
    async: async,
    url: rest_base + 'product/<%= product_id %>/runtime.json',
    method: 'get',
    url_params: {
      product_id: UUID
    }
  });

  this.load_lattice = http({
    async: async,
    url: rest_base + 'lattice/<%= lattice_id %>',
    method: 'get',
    url_params: {
      lattice_id: UUID
    }
  });

  this.do_reduce = http({
    async: async,
    url: rest_base + 'product/<%= product_id %>/behaviour',
    method: 'post',
    url_params: {
      product_id: UUID
    },
    form_params: {
      behaviour: t.maybe(Behaviour)
    }
  });

  this.do_share_purchase = http({
    async: async,
    url: rest_base + 'user/bonus/share',
    method: 'post',
    form_params: {
      product_id: t.maybe(UUID)
    }
  });

  this.do_accept_rcs_privacy = http({
    async: async,
    url: rest_base + 'user/account/privacy_rcs',
    method: 'post'
  });

}


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/Server.js
 **/